import { render, staticRenderFns } from "./SystemRoleManager.vue?vue&type=template&id=01ff2adc&scoped=true&"
import script from "./SystemRoleManager.vue?vue&type=script&lang=js&"
export * from "./SystemRoleManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ff2adc",
  null
  
)

export default component.exports